import React from 'react';
import PropTypes from 'prop-types';

export const Failed = ({ width, height, ...props }) => (
  <svg
    data-icon='failed'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M1 21v-2h22v2H1Zm3-3c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 2 16V5c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 4 3h16c.55 0 1.02.196 1.413.587C21.803 3.98 22 4.45 22 5v11c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 20 18H4Zm0-2h16V5H4v11Zm5.4-1.5 2.6-2.6 2.6 2.6 1.4-1.4-2.6-2.6L16 7.9l-1.4-1.4L12 9.1 9.4 6.5 8 7.9l2.6 2.6L8 13.1l1.4 1.4Z'
    />
  </svg>
);

Failed.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Failed.defaultProps = {
  width: 24,
  height: 24,
};
